export default "__VITE_ASSET__e070507b__"